// 页面公共布局
import PrimaryLayout from './PrimaryLayout'

export default PrimaryLayout
